<!-- LOGO START -->
<div
  *ngIf="isMenuOpen"
  class="bg-[url('/content/dam/delta-applications/ui-kit/assets/svg/delta-brand/supergraphic-flyout.svg')] bg-no-repeat h-[46px] w-[62px] bg-contain bg-right relative right-[72px] tablet:right-[147px] max-[992px]:mr-auto max-[992px]:absolute max-[992px]:left-[-28px] max-[992px]:top-[-6px] grayscale-effect"
></div>
<!-- LOGO END -->

<!-- MOBILE PRIMARY NAVIGATION TAB START -->
<div
  *ngIf="!collapsedHeader || viewSearchOptionExpanded"
  class="mobile-navbar-container-links pl-[10px]"
  id="mach-core-mobile-nav-primary"
>
  <ul
    [ngClass]="{
      relative: isMenuOpen,
      'max-[992px]:top-[20px]': isMenuOpen,
      'tablet:top-[-17px]': isMenuOpen,
      'gap-[22px]': !isMenuOpen,
      'gap-[64px]': isMenuOpen,
      hidden: isMenuOpen
    }"
    class="mobile-navbar-container-links--list flex p-l-[0px] mb-0 list-none text-inverse"
    id="mobile-navbar-container-links"
  >
    <li
      *ngFor="
        let navItem of content.primary;
        first as isFirst;
        last as isLast;
        let i = index
      "
      [ngClass]="{ 'min-[375px]:max-[767px]:hidden': isLast && isMenuOpen }"
      class="whitespace-nowrap mobile-navbar-item text-label-md-semibold"
      id="mach-core-mobile-nav-primary-item-{{ i }}"
    >
      <div
        role="button"
        tabindex="0"
        (click)="
          onTrackingObject(navItem.id);
          selectedNavItem(
            navItem.id,
            navItem.redirectMobile,
            navItem.redirectMobileUrl
          )
        "
        (keydown.enter)="
          selectedNavItem(
            navItem.id,
            navItem.redirectMobile,
            navItem.redirectMobileUrl
          )
        "
        (keydown.space)="
          selectedNavItem(
            navItem.id,
            navItem.redirectMobile,
            navItem.redirectMobileUrl
          )
        "
        [attr.aria-expanded]="selectedNav === navItem.id"
        [ngClass]="{
          'p-6 leading-[0.875rem] tracking-normal mt-0 mb-0': isMenuOpen
        }"
        class="text-white no-underline text-label-xs-semibold py-[4px] app-link  mobile-navbar-item--link-{{
          navItem.label | lowercase
        }}"
        href="javascript:void(0);"
        id="mach-core-mobile-nav-primary-link-{{ i }}"
      >
        {{ navItem.label }}
      </div>
      <aside
        *ngIf="selectedNav === navItem.id && !isMenuOpen"
        class="bg-button-primary flex items-center justify-center rounded-full h-[4px] mt-[4px]"
      ></aside>
    </li>
  </ul>
</div>
<!-- MOBILE PRIMARY NAVIGATION TAB END -->

<!-- MOBILE SECONDARY NAVIGATION TAB START -->
<div
  class="mobile-nav-links__secondary-nav w-screen pt-[24px] px-[32px] tablet:px-[120px] flex flex-col h-[92dvh] overflow-y-auto"
  *ngIf="isMobileDevice && isMenuOpen"
  id="mach-core-mobile-nav-secondary"
>
  <!-- Home Link -->
  <li
    role="none"
    [ngClass]="{
      'mobile-nav-links__home-item--active': selectedNav === 'book'
    }"
    *ngIf="isMobileDevice && isMenuOpen"
    class="mobile-nav-links__home-item list-none text-label-xs-semibold text-inverse"
    id="mach-core-mobile-nav-home-item"
  >
    <svg
      class="my-[8px] w-full"
      xmlns="http://www.w3.org/2000/svg"
      height="1"
      viewBox="0 0 526 1"
      fill="none"
      preserveAspectRatio="none"
    >
      <path
        d="M0 0.5H526"
        [attr.stroke]="isBusiness ? '#3a4351' : '#353F69'"
      ></path>
    </svg>

    <a
      [ngClass]="{ 'mobile-nav-links__home-link--mobile': isMobileDevice }"
      class="text-white no-underline text-label-xs-semibold text-inverse inline-block py-[12px] ml-[16px]"
      href="/"
      id="navBarHomeLink"
    >
      Home
    </a>
    <svg
      class="my-[8px] w-full"
      xmlns="http://www.w3.org/2000/svg"
      height="1"
      viewBox="0 0 526 1"
      fill="none"
      preserveAspectRatio="none"
    >
      <path
        d="M0 0.5H526"
        [attr.stroke]="isBusiness ? '#3a4351' : '#353F69'"
      ></path>
    </svg>
  </li>

  <li
    *ngFor="
      let navItem of content.primary;
      first as isFirst;
      last as isLast;
      let i = index
    "
    class="mobile-nav-links__home-item list-none text-label-xs-semibold text-inverse"
    id="mach-core-mobile-nav-secondary-item-{{ i }}"
  >
    <a
      [id]="navItem.id"
      (click)="
        onTrackingObject(navItem.id, navItem.label);
        selectedNavItem(
          navItem.id,
          navItem.redirectMobile,
          navItem.redirectMobileUrl
        )
      "
      [attr.aria-expanded]="selectedNav === navItem.id"
      class="text-white no-underline text-label-xs-semibold text-inverse inline-block py-[12px] ml-[16px]"
      href="javascript:void(0);"
      id="mach-core-mobile-nav-secondary-link-{{ i }}"
    >
      {{ navItem.label }}
    </a>
    <svg
      class="my-[8px] w-full"
      xmlns="http://www.w3.org/2000/svg"
      height="1"
      viewBox="0 0 526 1"
      fill="none"
      preserveAspectRatio="none"
    >
      <path
        d="M0 0.5H526"
        [attr.stroke]="isBusiness ? '#3a4351' : '#353F69'"
      ></path>
    </svg>
  </li>

  <div
    id="mobile-nav-links__secondary-item"
    class="mobile-nav-links__secondary-item"
    *ngFor="let secNavItem of content.secondary; let i = index"
  >
    <details
      class="accordion accordion-base !bg-transparent shadow-none"
      id="multi-select-accordion-1"
      name="multi-select-accordion"
      tabindex="0"
      (click)="
        onTrackingObject(secNavItem.id, secNavItem.label);
        onSecondaryNavActionToggle(secNavItem.id)
      "
      (keydown.enter)="onSecondaryNavActionToggle(secNavItem.id)"
    >
      <summary tabindex="0" id="mach-core-mobile-nav-accordion-summary-{{ i }}">
        <div
          class="accordion-summary"
          tabindex="-1"
          id="mach-core-mobile-nav-accordion-summary-content-{{ i }}"
        >
          <h6 class="text-inverse text-label-xs-semibold">
            {{ secNavItem.label }}
          </h6>
          <div class="accordion-caret ml-auto">
            <svg class="accordion-caret-icon text-icon-secondary"></svg>
          </div>
        </div>
      </summary>
      <div
        class="accordion-content"
        tabindex="0"
        id="mach-core-mobile-nav-accordion-content-{{ i }}"
      >
        <div class="text-inverse text-label-xs-semibold pb-16" tabindex="-1">
          <idp-app-sec-links-seo
            [content]="secNavItem"
            [isMobile]="isMobileDevice"
            [isAlertAdvisory]="isAlertAdvisory"
          ></idp-app-sec-links-seo>
        </div>
      </div>
    </details>
    <svg
      class="my-[8px] w-full"
      xmlns="http://www.w3.org/2000/svg"
      height="1"
      viewBox="0 0 526 1"
      fill="none"
      preserveAspectRatio="none"
    >
      <path
        d="M0 0.5H526"
        [attr.stroke]="isBusiness ? '#3a4351' : '#353F69'"
      ></path>
    </svg>
  </div>
  <!-- MOBILE SECONDARY NAVIGATION TAB END -->
</div>
